import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

// Dispatched in development by the translations hot reload client of @dhl/webpack-config, keep in sync
const translationsUpdatedEvent = 'dhl:translations-updated'

/** Refetches the translations when they've been changed during development, without a full page reload. */
export const useTranslationsHotReload = (): void => {
  const { i18n } = useTranslation()

  useEffect(() => {
    const onTranslationsUpdated = (event: Event) => {
      // Signals the hot reload client that the update is handled, so it won't reload the page
      event.preventDefault()

      // Changing to the current language triggers a re-render of all components using translations
      i18n.reloadResources().then(() => i18n.changeLanguage(i18n.language))
    }

    window.addEventListener(translationsUpdatedEvent, onTranslationsUpdated)

    return () => window.removeEventListener(translationsUpdatedEvent, onTranslationsUpdated)
  }, [i18n])
}
